export default {"src":"/_next/static/media/DiskIcon.30dd330b.svg","height":75,"width":91};